import React from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/routes';
import Page from 'src/components/Page';
import SpecLink from 'src/components/SpecLink';
import Table from 'src/components/Table';

function TwoPartyTxnProcessingPage() {
    return <Page header="2-party AuthKey">
        <p>
            2-party AuthKey transaction processing involves the merchant passing transaction details (including card or account numbers) directly to BPOINT.
            This involves the merchant first <SpecLink uriFragment="#operation/TxnAuthkey_CreateAuthkey">obtaining an auth key</SpecLink> from BPOINT which can then be used for subsequent operations.
        </p>
        <p>
            To make a payment you must, at minimum, perform the following:
        </p>
        <ol>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_CreateAuthkey">Create authkey</SpecLink></li>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_AttachTxnDetails">Attach transaction details</SpecLink></li>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_AttachPaymentMethod">Attach payment method (card or bank account account details)</SpecLink></li>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_Process">Process transaction</SpecLink></li>
        </ol>
        <p>
            If <b>Authentication (3D Secure)</b> is active with your integration, complete:
            <ol>
                <li><code>emailAddress</code> on <SpecLink uriFragment="#operation/TxnAuthkey_AttachTxnDetails">Attach transaction details</SpecLink></li>
                <li><code>name</code> on <code>card</code> details for <SpecLink uriFragment="#operation/TxnAuthkey_AttachPaymentMethod">Attach payment method</SpecLink></li>
            </ol>
        </p>
        <p>
            A more comprehensive description of the different 2-party txn flows can be found <Link exact to={routes.api.txn.authkey.flow}>here</Link>.
        </p>
        <p>
            Other supplementary options and flows can also be used:
        </p>

        <Table
            headers={['Option', 'Description']}
            body={[
                ['Authentication', 'Customer completes 3D Secure verification, reducing fraudulent transactions'],
                ['Surcharging rate display', 'Retrieve biller surcharge details for display to customer'],
                ['Surcharge confirmation', 'Retrieve transaction surcharge details for display to customer'],
                ['Fraud screening', 'Advanced fraud screening can be enabled. Additional transaction details can also be submitted for more effective fraud screening.'],
                ['Statement descriptor', 'Contact information to be printed on the cardholders\' account statements'],
                ['With token', 'Use a token instead of actual card or bank account numbers'],
            ]}
        />
    </Page>
}

export default TwoPartyTxnProcessingPage;
